import './ErrorAlert.scss';

import { mdiReplay } from '@mdi/js';
import type { ApiError } from 'common/models';
import Alert from 'components/Alert/Alert';
import Button from 'components/Button/Button';
import Icon from 'components/Icon/Icon';
import { useCustomTranslation } from 'helpers/translationHelper';
import React from 'react';

interface Props {
  error: ApiError;
  onRetry?: () => void;
  type?: 'success' | 'info' | 'warning' | 'error';
}

const QueryErrorAlert: React.FC<Props> = (props): React.ReactElement => {
  const { tCommon } = useCustomTranslation();

  return (
    <Alert
      className="ErrorAlert"
      description={props.error.response?.data.errorMessage}
      message={props.error.response?.data.title}
      type={props.type || 'error'}
      action={
        props.onRetry && (
          <Button onClick={props.onRetry} icon={<Icon path={mdiReplay} />}>
            {tCommon('retry')}
          </Button>
        )
      }
    />
  );
};

export default QueryErrorAlert;
